'use client'

import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { noop } from 'lodash'

import { INBOX_URL } from '@marketplace-web/messaging/conversation-messaging-data'
// TODO: will be handled as part of `ConversationContent` & `ConversationHeader` refactor
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ConversationHeader } from '@marketplace-web/messaging/conversation-messaging-feature'
import { BrazeInboxMessage, useBrazeInboxMessageCards } from '@marketplace-web/braze/braze-feature'

import { invariant, errors } from '../../utils'
import MessageTime from '../MessageTime'

type Props = {
  conversationId: string
}

const BrazeConversation = ({ conversationId }: Props) => {
  const { inboxMessageCards } = useBrazeInboxMessageCards()

  invariant(inboxMessageCards, new errors.InboxMessageCardsNotLoadedError())

  const brazeConversationCard = useMemo(
    () => inboxMessageCards.find(card => card.id === conversationId),
    [conversationId, inboxMessageCards],
  )

  invariant(brazeConversationCard, new errors.InboxMessageCardNotFound({ cardId: conversationId }))

  const navigate = useNavigate()

  const handleGoBack = () => navigate(INBOX_URL)

  return (
    <div className="thread__wrapper">
      <div className="thread__messages-container">
        <ConversationHeader
          oppositeUser={null}
          onInfoIconClick={noop}
          onGoBack={handleGoBack}
          onUsernameClick={noop}
          isSystem
        />
        <div className="thread__messages-wrapper">
          <div className="thread__messages-main">
            <div className="thread__content" data-testid="conversation-content">
              <div className="u-ui-margin-top-large">
                <BrazeInboxMessage
                  card={brazeConversationCard}
                  prefix={<MessageTime card={brazeConversationCard} />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BrazeConversation
